import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import MapView from "./MapView";
import Sidebar from "./UI/Sidebar";
import { Maximize, Minimize } from "react-feather";

const DashboardLayout = () => {
  const [isFullscreen, setFullscreen] = useState(false);
  return (
    <div className="dash-wrap flex items-center h-screen py-4 pr-4 fixed w-full">
      <div className="side-bar">
        <Sidebar />
      </div>
      <div className={`app-content w-1/2 ${isFullscreen?"hidden":"visible"} h-full overflow-y-scroll px-6`}>
        <Outlet />
      </div>
      <div
        className={`map-view relative ${isFullscreen?"w-full ml-4":"w-1/2"} border border-slate-400 h-full rounded-xl overflow-hidden`}
      >
        <div
          onClick={() => setFullscreen(!isFullscreen)}
          style={{ transform: "translateX(-100%)" }}
          className="fullscreen absolute z-20 top-100 left-[100%] p-4 cursor-pointer hover:bg-tblu/50 hover:text-white transition-all rounded-xl"
        >
          {isFullscreen? <Minimize/> :<Maximize />}
        </div>
        <MapView />
      </div>
    </div>
  );
};

export default DashboardLayout;
